import { withTrialDueDateEnd } from "./TrialCalendarDates";

const normalize = (value) =>
  String(value == null ? "" : value).normalize("NFKC").toLowerCase().trim();

const compact = (value) => normalize(value).replace(/[^a-z0-9ก-๙]+/g, "");

export const getTrialPatientName = (props = {}) =>
  [props.FirstName || props.firstname, props.LastName || props.lastname]
    .filter(Boolean)
    .join(" ");

export const matchesTrialFilters = (event, searchText, nodeName) => {
  const props = event.extendedProps || {};
  if (nodeName && nodeName !== "All Node" && props.nodeRef !== nodeName) {
    return false;
  }
  const search = normalize(searchText);
  if (!search) return true;
  const compactSearch = compact(search);
  return [props.order, event.title, props.HN || props.hn, getTrialPatientName(props)]
    .some((value) => normalize(value).includes(search) ||
      (compactSearch && compact(value).includes(compactSearch)));
};

export const getTrialCalendarDisplay = (events, searchText, nodeName) => {
  events = events.map(withTrialDueDateEnd);
  const visibleEvents = events.filter((event) =>
    matchesTrialFilters(event, searchText, nodeName),
  );
  const visible = new Set(visibleEvents);
  return {
    visibleEvents,
    // Retain hidden cases in FullCalendar's store for existing duplicate-HN checks.
    events: events.map((event) => ({
      ...event,
      // Legacy records reuse id "6"; FullCalendar needs unique IDs on reset.
      id: (event.extendedProps && event.extendedProps.uuid) || event.id,
      display: visible.has(event) ? event.display || "auto" : "none",
    })),
  };
};
